export const environment = {
  production: false,
  // fbAppId: 186848361921511,
    googleWebClientId: '829934903422-n59c8srk5cqrh1qorbbv64sug2hj4vhs.apps.googleusercontent.com',
  firebase: {
    apiKey: "AIzaSyDcbM8K2oe8xzpiU1gPKUe39eBynXGQqnw",
    authDomain: "drinkin-17205.firebaseapp.com",
    databaseURL: "https://drinkin-17205.firebaseio.com",
    projectId: "drinkin-17205",
    storageBucket: "drinkin-17205.appspot.com",
    messagingSenderId: "393646169293"
  }
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts